import { createColumnHelper } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import DataTable from "../../../components/dataTable/DataTable";
import { ApiEndpoints, reqGet } from "../../../config/apiClient";
import styles from "./styles.module.css";

export default function ModalPesquisarColaboradores({ show, handleAdicionarColaborador, handleClose }: iProps) {
    const [dados, setDados] = useState<any[]>([])
    const [dadosFiltrados, setDadosFiltrados] = useState<any[]>([])
    const [mostrarDemitidos, setMostrarDemitidos] = useState<boolean>(false)
    
    useEffect(() => {
        getDados()
    }, [])
    async function getDados() { 
        const api = await reqGet(ApiEndpoints.documentosListarColaboradores)
        if (api.status === 200) { 
            let cols:any[] = api.data
            setDados(api.data)
            let aux = cols.filter((reg) => reg.id_situacao.codigo !== 8)
            setDadosFiltrados(aux)
        }
    }
    
    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dadosFiltrados[idx]
        if (event.button === 1) {
            handleAdicionarColaborador(reg)
        }
    }
    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dadosFiltrados[idx]
        if (event.button === 0) {
            handleAdicionarColaborador(reg)
        }
    }
    
    function handleChangeFiltro(event:any) { 
        const status = !mostrarDemitidos
        if (status === true) {
            setDadosFiltrados(dados)
        } else { 
            let aux = dados.filter((reg) => reg.id_situacao.codigo !== 8)
            setDadosFiltrados(aux)
        }
        setMostrarDemitidos(status)
    }
    
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={true} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Adicionar colaborador como signatário:</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Check type="switch" id="colaboradores_mostrar_demitidos" label="Mostrar Colaboradores Desativados" className={styles.inputCheck} onChange={(event) => handleChangeFiltro(event)} checked={mostrarDemitidos} />
                <br></br>
                <DataTable dados={dadosFiltrados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
interface iProps {
    show: boolean;
    handleAdicionarColaborador: any;
    handleClose: any;
}

const columnHelper = createColumnHelper<any>()
const defaultColumns = [
    columnHelper.accessor(row => `${row.matricula} - ${row.nome_completo}`, {
        header: 'Colaborador',
        size: 400,
    }),
    // columnHelper.accessor('nome_completo', {
    //     header: 'Colaborador',
    // }),
    columnHelper.accessor('cpf', {
        header: 'CPF',
    }),
    columnHelper.accessor('telefone', {
        header: 'Telefone',
    }),
    columnHelper.accessor('email', {
        header: 'E-mail',
    }),
    columnHelper.accessor(row => `${row.id_situacao.descricao}`, {
        header: 'Situação',
    }),
]
const defaultOrder:any = []
